/* eslint-disable */
/*
  Variables are stored in JS file, because there might be some cases where they
  will be required outside .vue file or before Vue instance had been initialized (no `this` access).
*/

const defaultAdminTab = 'cockpit';

const defaultEpsg = 'EPSG:3857';
const defaultEpsgName = 'EPSG:3857 (Google Mercator)';
const defaultSRID = 3857;
const defaultEpsgDefinition =
  '+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext  +no_defs';
const defaultEpsgExtent = [-20026376.39, -20048966.1, 20026376.39, 20048966.1];
const additionalEpsgs = {
  'EPSG:2180': {
    text: 'EPSG:2180 (PL-1992)',
    def:
      '+proj=tmerc +lat_0=0 +lon_0=19 +k=0.9993 +x_0=500000 +y_0=-5300000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +axis=neu',
    srid: 2180,
  },
};
const defaultEpsgsList = [
  {
    srid: 3857,
    text: 'EPSG:3857 (World Mercator)',
  },
  {
    srid: 4326,
    text: 'EPSG:4326 (WGS84)',
  },
  {
    srid: 4258,
    text: 'EPSG:4258 (ETRS89)',
  },
  {
    srid: 2180,
    text: 'EPSG: 2180 (PL-1992)',
  },
  {
    srid: 2176,
    text: 'EPSG: 2176 (PL-2000 V)',
  },
  {
    srid: 2177,
    text: 'EPSG: 2177 (PL-2000 VI)',
  },
  {
    srid: 2178,
    text: 'EPSG: 2178 (PL-2000 VII)',
  },
  {
    srid: 2179,
    text: 'EPSG: 2179 (PL-2000 VIII)',
  },
  {
    srid: 3120,
    text: 'EPSG: 3120 (PL-1965 I)',
  },
  {
    srid: 2172,
    text: 'EPSG: 2172 (PL-1965 II)',
  },
  {
    srid: 2173,
    text: 'EPSG: 2173 (PL-1965 III)',
  },
  {
    srid: 2174,
    text: 'EPSG: 2174 (PL-1965 IV)',
  },
  {
    srid: 2175,
    text: 'EPSG: 2175 (PL-1965 V)',
  },
  {
    srid: 3333,
    text: 'EPSG: 3333, (PL-1942 6° III)',
  },
  {
    srid: 3334,
    text: 'EPSG: 3334, (PL-1942 6° IV)',
  },
  {
    srid: 3335,
    text: 'EPSG: 3335, (PL-1942 6° V)',
  },
  {
    srid: 3329,
    text: 'EPSG: 3329, (PL-1942 3° V)',
  },
  {
    srid: 3330,
    text: 'EPSG: 3330, (PL-1942 3° VI)',
  },
  {
    srid: 3331,
    text: 'EPSG: 3331, (PL-1942 3° VII)',
  },
  {
    srid: 3332,
    text: 'EPSG: 3332, (PL-1942 3° VIII)',
  },
];

const minEditingZoom = 16;
const defaultMinZoom = 7;

export {
  defaultEpsg,
  defaultEpsgName,
  defaultEpsgDefinition,
  defaultAdminTab,
  defaultEpsgExtent,
  defaultSRID,
  defaultEpsgsList,
  defaultMinZoom,
  minEditingZoom,
  additionalEpsgs
};
